import { Col, Row } from "react-bootstrap";
import "./Infobox.css";
import React from "react";

export function Infobox() {
  return (
    <>
      <Row className="infobox mt-5">
        <Col lg={2} md={0} />
        <Col lg={8} md={12}>
          <div className="infoboxText">
            <Row>
              <Col className="titleImageInfo d-flex justify-content-center">
                <div>
                  <h1>WAT IS HOME KONVENT?</h1>
                  <img src="konvent.png" alt="HK schild" />
                </div>
              </Col>
              <Col className="textMarginSmallScreen">
                <p className="mt-5">
                  Het Home Konvent (HK) is de{" "}
                  <strong>overkoepelende organisatie</strong> boven de
                  individuele homes.
                </p>
                <p>
                  Maandelijks vindt er een IHR (InterHomeRaad) plaats, waarbij
                  de Dienst Huisvesting ook aanwezig is. Daar worden
                  infrastructuurproblemen aangekaart en worden er overkoepelende
                  activiteiten georganiseerd (bijvoorbeeld het galabal, Inter
                  Homesvoetbal, etc.). In het algemeen worden zaken op een hoger
                  en uitgebreider niveau besproken dan van de individuele homes.
                </p>
                <p>
                  HK Centraal vormt het dagelijks bestuur en is een
                  aanspreekpunt voor de homeraden van de individuele homes.
                </p>
              </Col>
            </Row>
          </div>
        </Col>
        <Col lg={2} md={0} />
      </Row>
    </>
  );
}
